import React, { useEffect } from "react"
import Section from "../../../../core/layout/main/section/Section.js"
import Container from "../../../../core/layout/main/container/Container.js"
import { navigate } from "gatsby"

function autoResize(id){
  var newht;
  var newwt;

  if(document.getElementById){
      newht=document.getElementById(id).contentWindow.document.body.scrollHeight;
      newwt=document.getElementById(id).contentWindow.document.body.scrollWidth;
  }

  document.getElementById(id).height=(newht) + "px";
  document.getElementById(id).width=(newwt) + "px"; 
}

const ConversionFormSection = ({}) => {


 useEffect(() => {
    if (typeof window !== undefined) {
      window.addEventListener(
        "message",
        (event) => {
          console.log("message!!!", event)
          if (event.data.type === "pop-in") {
            navigate(event.data.url, {
              state: {
                modal: true,
              },
            })
          }

          if (event.data.type === "navigate") {
            window.location = event.data.url
          }
        },
        false
      )
    }
  }, [])

  console.log('window',  typeof window !== 'undefined' && window)

  console.log('location',  typeof window !== 'undefined' && window.location)

  const isInPopin = typeof window !== 'undefined' && window.location.pathname?.includes("pop-in")

  return isInPopin ? (
    <iframe
      src={process.env.GATSBY_CONV_BASE_URL}
      style={{ width: "800px", height: "960px" }}
    />
  ) : (
    <Section>
      <Container>
        <iframe
          src={process.env.GATSBY_CONV_BASE_URL}
          style={{ width: "100%", height: "1000px" }}
        />
      </Container>
    </Section>
  )
}

export const name = "ConversionFormSection"

export const init = (componentData, pageContext) => {
  return <ConversionFormSection />
}

export default ConversionFormSection
